import React, { memo } from "react";
import {
	Row
} from "reactstrap";

const Details = memo( function Details({
	user, totalQuestions, time
}) {

	return (
		<Row className='unselectable'>
			<div className="col-lg-12">
				<div className="timeRemaining">
					<p>
						<i className="fa fa-clock-o"></i>
						<span>Time Remaining: {time} minutes</span>
					</p>
				</div>
				<h4 className="mt-0">Welcome {user.first_name} {user.last_name}</h4>
				<div className="col-xs-12">
					<table className="table table-bordered">
						<thead>
							<tr>
								<th>Section</th>
								<th>No. of Question</th>
								<th>Time Allowed</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Reading</td>
								<td>{totalQuestions}</td>
								<td>{time} minutes</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</Row>
	);
});

export default Details;